export class GEObject {
	listeners = {}	
	deferUpdates = false
	off(event, cb) {
		if (!this.listeners[event]) {
			return;
		}
		this.listeners[event] = this.listeners[event].filter((c) => c != cb);
	}
	on(event, cb) {
		if (!this.listeners[event]) {
			this.listeners[event] = [];
		}
		this.listeners[event].push(cb);
	}
	removeAllEventListerners() {
		this.listeners = {}
	}
	trigger(event, target, data) {
		if(this.deferUpdates) {
			return
		}
		if (!this.listeners[event]) {
			return;
		}
		for (let cb of this.listeners[event]) {
			cb(this, target, data);
		}
	}
}